import { fork } from '@redux-saga/core/effects';
import { doFetchModel } from 'features/page-model/ducks/get-model';
import { doFetchProductC14s } from 'features/product-characterstics/ducks/product-charactristics';
import { doFetchProductData } from 'features/product-info/ducks/product-main-info';
import { doFetchProductMedia } from 'features/product-info/ducks/product-media';
import { runReviewsPageRefetch } from 'features/reviews';
import { doFetchMeasurementSettings } from 'features/basket/ducks/measurement-settings';
import { runFetchRelatedProducts } from 'features/related-products';
import { doFetchRelatedServices } from 'features/related-services';

export function* fetchState() {
  yield fork(doFetchModel);
  yield fork(doFetchProductData);
  yield fork(doFetchProductMedia);
  yield fork(doFetchMeasurementSettings);
  yield fork(doFetchProductC14s);
  yield fork(runReviewsPageRefetch);
  yield fork(runFetchRelatedProducts);
  yield fork(doFetchRelatedServices);
}
